import './App.css';

import { BrowserRouter as Router, Routes, Route, Switch, Link } from "react-router-dom";
import { ReactNotifications } from 'react-notifications-component'
import  CreateRide  from './pages/CreateRide.jsx'

import CancelRide from './pages/CancelRide';
import AddPayment from './pages/AddPayment';
import Signup from './pages/Signup';
import Login from './pages/Login';
import { useState, useEffect } from 'react';
import NavBar from './components/NavBar';
import { getUserInfo } from './firebase/FirebaseManagement';
import { auth } from './firebase/FirebaseConfig';
import ProtectedRoute from './components/ProtectedRoute';
import AboutUs from './pages/AboutUs';
import Home from './pages/Home';
import MessagesChat from './pages/MessagesChat';
import ChatRoom from './pages/ChatRoom';
import RexRideCheckout from './pages/RexRideCheckout';

import './styles/stylesass.scss';


import RideReviewSubmit from "./pages/RideReviewSubmit"

import AllRexRides from './pages/AllRexRides';
import MyRides from './pages/MyRides';
import RexRideDetails from './pages/RexRideDetails';
import { AuthContext } from './context/AuthContext';
import { useContext } from 'react';

function App() {
  // Matias AuthContextProvider to check if user is logged in
  const { currentUser } = useContext(AuthContext);
  console.log(currentUser);
  // ProtectetRoute
  // const ProtectedRoute = ({ children }) => {
  //   if (!currentUser) {
  //     return <Navigate to="/login" />;
  //   }
  // };

  // ============================================================/
  const [account, setAccount] = useState();
  const [user, setUser] = useState();
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        fetchUserInfo();
        // User is signed in
      } else {
        setAccount(undefined);
      }
    });

    return () => unsubscribe();
  }, [user]);

  const fetchUserInfo = async () => {
    var userId = localStorage.getItem('userId');
    var userInfo = await getUserInfo(userId);
    if (userInfo) {
      setAccount(userInfo);
    }
  };
  return (

    <div >
      
      <ReactNotifications className='notifications' />
     <Router>

        <NavBar account={account} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cancelride/:rideId" element={<CancelRide />} />

          <Route path="/addpayment" element={<AddPayment />} />
          <Route path="/messages-chat" element={<MessagesChat />} />
          <Route path="/messages-chat/:userId" element={<ChatRoom />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route
            path="/rexridecheckout/:rideId"
            element={<RexRideCheckout />}
          />
          <Route
            exact
            path="/create-ride"
            element={
              <ProtectedRoute>
                <CreateRide />
              </ProtectedRoute>
            }
          />
          <Route path="/allrexrides" element={<AllRexRides />} />
          <Route path="/myrides" element={<MyRides />} />

          

          
          <Route  path="/ridereviewsubmit/:rideId" element={<RideReviewSubmit />} />
          
       

          <Route path="/rexridedetails/:rideId" element={<RexRideDetails />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
